module.exports = __webpack_public_path__ + "assets/img/btn-detail-f77d307c.png";